import React from "react";
import PropTypes from "prop-types";
import { FormControl, Select, MenuItem, Typography, FormHelperText } from "@mui/material";

function CustomSelect({
  label,
  value,
  onChange,
  options,
  name,
  required,
  placeholder,
  error,
  helperText,
  ...rest
}) {
  return (
    <FormControl fullWidth sx={{ mb: 2 }} error={error} required={required}>
      <Typography fontWeight="bold" fontSize="16px" mb={0.5} color="text.primary">
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </Typography>
      <Select
        name={name}
        value={value ?? ""}
        onChange={onChange}
        displayEmpty
        fullWidth
        sx={{
          borderRadius: "8px",
          backgroundColor: "#fff",
          height: "40px !important",
          "& .MuiSelect-select": {
            paddingY: "6px",
            paddingX: "12px",
          },
        }}
        {...rest}
      >
        {placeholder && (
          <MenuItem disabled value="">
            {placeholder}
          </MenuItem>
        )}
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
      {error && helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

CustomSelect.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};

CustomSelect.defaultProps = {
  name: "",
  value: "",
  placeholder: "",
  required: false,
  error: false,
  helperText: "",
};

export default CustomSelect;
